import { render, staticRenderFns } from "./ContrAdminPanels.vue?vue&type=template&id=60986faa"
import script from "./ContrAdminPanels.vue?vue&type=script&lang=js"
export * from "./ContrAdminPanels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports